import { render, staticRenderFns } from "./CountriesQuestion.vue?vue&type=template&id=4450c20a&scoped=true&"
import script from "./CountriesQuestion.vue?vue&type=script&lang=ts&"
export * from "./CountriesQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./CountriesQuestion.vue?vue&type=style&index=0&id=4450c20a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4450c20a",
  null
  
)

export default component.exports